/*
 * @Author: wonderswang
 * @Date: 2023-5-6 15:52:20
 * @LastEditTime: 2023-05-21 16:52:13
 * @LastEditors: juanjualong juanjualong@tencent.com
 * @Description: 由于tdesign暂时没升级到1.2+，导致函数式调用dialog方法里的默认按钮未翻译。等到tdesign升级之后，此文件可以删除并将代码还原。
 * @FilePath: /smh-drive-client/src/scripts/utils/CustomDialog
 */
import { DialogPlugin } from 'tdesign-vue';
import { DialogOptions } from 'tdesign-vue/es/dialog/type';
import { i18n_t } from '@/locales/i18n';

export default {
  alert: (options: DialogOptions) => {
    options.confirmBtn = options.confirmBtn !== null ? options.confirmBtn || i18n_t('确认') : null;
    return DialogPlugin.alert(options);
  },
  confirm: (options: DialogOptions) => {
    options.cancelBtn = options.cancelBtn !== null ? options.cancelBtn || i18n_t('取消') : null;
    options.confirmBtn = options.confirmBtn !== null ? options.confirmBtn || i18n_t('确认') : null;
    return DialogPlugin.confirm(options);
  },
};
